import { AnalyticsApi } from './api';
import { IAnalyticsDashboard } from './state';
import { actions } from './store';

const { setDashboards, setDashboardsLoading, setDashboardsError } = actions;

export const fetchDashboardsAction =
	({ customerId, userEmail }: { customerId: string; userEmail: string }) =>
	async (dispatch: any) => {
		try {
			dispatch(setDashboardsLoading(true));
			const response = await AnalyticsApi.getDashboards({ customerId, userEmail });
			const accessibleDashboardResponseList =
				response?.data?.responseObject?.accessibleDashboardResponseList || [];

			if (Array.isArray(accessibleDashboardResponseList)) {
				const accessibleDashboards = accessibleDashboardResponseList.filter(
					(dashboard: IAnalyticsDashboard) => dashboard.accessible
				);

				dispatch(setDashboards(accessibleDashboards));
			}
		} catch (error) {
			console.error('Error fetching dashboards:', error);
			dispatch(setDashboardsError(true));
		} finally {
			dispatch(setDashboardsLoading(false));
		}
	};
